var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "group",
      class: {
        "group--open": _vm.open,
      },
    },
    [
      _c(
        "div",
        { staticClass: "group-header", staticStyle: { width: "100%" } },
        [
          _c("div", { staticClass: "group-header__wrapper" }, [
            _c(
              "button",
              {
                staticClass: "group__toggler",
                attrs: { type: "button" },
                on: { click: _vm.toggle },
              },
              [
                _c("svg-icon", {
                  attrs: {
                    size: 22,
                    name: "chevron-top-circled",
                    color: "primary",
                  },
                }),
              ],
              1
            ),
            _c("div", { staticClass: "group__name" }, [
              _vm._v(_vm._s(_vm.group.name)),
            ]),
            _c("div", { staticClass: "group__count" }, [
              _vm._v(_vm._s(_vm.count)),
            ]),
          ]),
        ]
      ),
      _c("transition", { attrs: { name: "slide" } }, [
        _vm.open
          ? _c(
              "div",
              { staticClass: "group__list" },
              [
                _c("workers-list", {
                  ref: "list",
                  attrs: {
                    days: _vm.days,
                    "can-edit": _vm.canEdit,
                    "show-all": _vm.showAll,
                    frame: _vm.frame,
                  },
                }),
              ],
              1
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }